import { useMember } from '../../../../contexts/widgets';
import { useCascadingSettings } from '../../Settings/hooks';
import settingsParams from '../../settingsParams';
import stylesParams from '../../stylesParams';

export const useBadgesRenderer = () => {
  const cascadingSettings = useCascadingSettings();
  const { badges } = useMember();

  const showBadgesSection = cascadingSettings.get(
    settingsParams.showBadgesSection,
    stylesParams.showBadgesSection,
  );
  const hasBadges = badges.length > 0;

  return { shouldRenderBadges: showBadgesSection && hasBadges };
};
